import React from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import Tooltip from 'components/Tooltip';
import PropTypes from 'prop-types';
import { LISTINGS_FILTER_TAGS } from 'views/V2/Integration/constants';

import styles from './filter.module.css';

import { ReactComponent as CrossIcon } from 'asset/IconsPack/at_x-close.svg';
import { ReactComponent as PlusIcon } from 'asset/IconsPack/hx_plus.svg';

const getTooltipTitle = (tag, isFilterOn) => {
    if (isFilterOn) return 'Click to remove this filter';
    if (tag.key === 'enabled') return 'Click to view enabled listings';
    if (tag.key === 'disabled') return 'Click to view disabled listings';
    return '';
};

const Filter = ({ filters, onToggleFilter }) => (
    <Box className={styles.filterWrapper}>
        {LISTINGS_FILTER_TAGS.map((tag) => (
            <Tooltip
                key={tag.key}
                title={getTooltipTitle(tag, filters[tag.key])}
                placement="bottom-end"
                arrow
            >
                <Box
                    className={clsx(
                        styles.filterTag,
                        filters[tag.key] ? styles.filterTagActive : styles.filterTagInactive
                    )}
                    onClick={() => onToggleFilter(tag.key)}
                >
                    <span>{tag.label}</span>
                    <button
                        type="button"
                        className={styles.filterCloseButton}
                        onClick={(event) => {
                            event.stopPropagation();
                            onToggleFilter(tag.key);
                        }}
                    >
                        {filters[tag.key] ? (
                            <CrossIcon className={styles.filterCloseIcon} />
                        ) : (
                            <PlusIcon className={styles.filterPlusIcon} />
                        )}
                    </button>
                </Box>
            </Tooltip>
        ))}
    </Box>
);

Filter.propTypes = {
    filters: PropTypes.shape({
        enabled: PropTypes.bool,
        disabled: PropTypes.bool,
    }).isRequired,
    onToggleFilter: PropTypes.func.isRequired,
};

export default Filter;
